api = require('../api.coffee').api()

class global.NotificationsResource extends ResourceBase
  @MODEL = Notification
  @SINGULAR_RESOURCE_NAME = 'notification'
  @PLURAL_RESOURCE_NAME = 'notifications'

  index: (success, failure, params = {}) ->
    api.get "/notifications", params, { success: @collectionSuccess(success), failure }

  read: (success, failure, params = {}) ->
    api.put "/notifications/#{@getParamsId(params)}/read", params, { success: @memberSuccess(success), failure }

  readAll: (success, failure, params = {}) ->
    api.put "/notifications/read", params, { success, failure }



// WEBPACK FOOTER //
// ./src/resources/notifications.coffee